import { useEffect } from 'react';
import { useAssistantSafe } from './AssistantProvider';
import type { AssistantSubState } from './constants';

/**
 * Reports which part of a step is on screen to the assistant. Renders nothing.
 *
 * A leaf on purpose: subscribing to the assistant context re-renders on every change to it —
 * each message, each journal event — so the subscription is kept here rather than in the step,
 * which would drag the whole form along with it. Same shape as AssistantFormFields and
 * ValidationFailureJournal.
 */
export function AssistantSubStateReporter({ subState }: { subState: AssistantSubState }) {
  const setSubState = useAssistantSafe()?.setSubState;

  useEffect(() => {
    setSubState?.(subState);
  }, [subState, setSubState]);

  // Leaving the step is the only thing that should clear it.
  useEffect(() => () => setSubState?.(undefined), [setSubState]);

  return null;
}
